//  <FileHeader xmlns="http://www.gordic.cz/shared/file-header/v_1.0.0.0">
//    <Name>        Gordic.Pod.WebControls.OdeslaneListPage.ts                  </Name>
//    <Description>                                                             </Description>
//    <Author>      Jiří Šindelka                                               </Author>
//    <Copyright>   © GORDIC spol. s r. o. 1993-2020                            </Copyright>
//    <Created>     2020-12-30                                                  </Created>
//  </FileHeader>

namespace Gordic.Pod.Lists
{
    @Decorators.gcontent
    export class OdeslaneListPage extends GContentBase<PodDokSpisListBasePage>
    {
        model: Wfl.Interface.GSeznamFilterBaseDto;

        onContentReady() {
            const that = this;
            PodDokSpisListBasePage.InitList(this);
            Gordic.Wfl.ListAC.WflListBaseAC.CompleteMenu(this);

            // samotná definice gfilterpanelu
            this.filterForm = $("<div>")
                .appendTo(this.element)
                .on("gfilterpanelapply", function (event, obj) {         // eventa která je vyvolána při vyhledávání. obj.filter -> hledaný seznam podmínek
                    that.LoadData(obj.filter);
                }).gfilterpanel({
                    forms: this.CreateFilterForms(), // poleFormu ktere budou pouzity pro podminky
                    // 01.03.2021 - TFeik
                    // Nahrazení obsolete parametrů.
                    filterViewMode: FilterViewMode.Simple,
                    //simpleMode: true,
                    favorites: "all",
                    filterStorageService: new Gordic.Gin.FilterStorageService.Store({ tema: "pod_ptm_dspreo" }),
                    favoriteLayoutDescriptor: Gordic.Gin.Globals.Enums.LayoutDescriptorType.list,
                    poVyhledaniZobrazit: "OblibenePodminky"
                })

            Wfl.ListAC.DokSpisListBaseAC.CreateGridDokSpis(this);
            this.filterForm.gfilterpanel("applyFilter", this.model, !this.NacistSeznamPriOtevreni)
        }

        CreateFilterForms() {
            var filterForm = new Gordic.Forms.Form({ name: "FormDocsList", tabLabel: "", layoutDescriptor: "L2M2S1, L-3-8-1, M-12-11-1, S-12-11-1, breaks-700-1000" }); //RC 26285623 : Filtr balíků
            filterForm.addField("gdatecombobox", {
                    name: "DatumField",
                    model: "model.Datum=value.date",
                    defaultInitialValue: "all",
                    daysRangeMax: this.DaysRangeMax,
                    contextMenu: {
                        daysRange: 50
                    },
                    userSettings: this.userSettings,
                });
            return [filterForm];
        }

        LoadData(filtr?: Wfl.Interface.GSeznamFilterBaseDto) {
            var that = this;
            Gin.Globals.ShowWaitLoadData(this);
            //nacteni dat do gridu
            this.call<Wfl.Interface.DokSpisListDto[]>("LoadData", { "model": filtr })
                .done(function (data) {
                    var view = new Gordic.Data.View(data, { key: that.IDPrimaryKeyGridu });  //key je dulezity kvuli pripadnemu vyhledavani radku
                    that.mainGrid.ggrid("setData", view);
                })
                .always(function () { Gordic.Wfl.ListAC.WflListBaseAC.AfterLoadData(that); });
        }

        ReloadData() {
            this.LoadData(this.model);
        }
    }
};
